// Place constants in here that should be defined only once but will be reused across the app

export const DISCORD_INVITE = 'https://discord.com/invite/DyMV2bHARz';
